import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IMLPolicyResponse, IProposal } from 'Models/ResponseModels'
import { TMotorProposalFormType } from 'Pages/Motor/Proposal/Forms/FormModel'
import { ToastService } from 'Services/toast.service'


export type inputTypes= 'firstName'|'lastName'|'middleName'|'email'|'dob'|'address1'|'address2'|'mobileNumber'
interface IState {
  proposalStatus: 'success' | 'loading' | 'error' | 'not-fetched'
  proposalScreen: 'one' | 'two'
  proposalDetails: TMotorProposalFormType
  proposalSuccessResponse: IProposal
  proposalErrorResponse: string
  readOnlyInputs:inputTypes[]
}

const initialState: IState = {
  proposalStatus: 'not-fetched',
  proposalScreen: 'one',
  proposalDetails: {
    isLoan: false,
    salutation: 'Mr.',
    isGenderMale: true,
    isMarried: false,
  },
  proposalSuccessResponse: {},
  proposalErrorResponse: '',
  readOnlyInputs:[]

  
}

const proposalPageSlice = createSlice({
  name: 'proposalPage',
  initialState: initialState,
  reducers: {
    updateReadOnlyInputs: (state, action:PayloadAction<inputTypes[]>) => { 
        state.readOnlyInputs = action.payload
    },
    toggleProposalScreen: (state, action: PayloadAction<'one' | 'two'>) => {
      state.proposalScreen = action.payload
    },
    updateProposalDetails: (state, action: PayloadAction<TMotorProposalFormType>) => {
      const {
        engineNumber,
        chassisNumber,
        previousPolicyNumber,
        isLoan,
        bankName,
        usesType,
        salutation,
        firstName,
        middleName,
        lastName,
        isGenderMale,
        isMarried,
        panCard,
        mobileNumber,
        email,
        pincodeArea,
        occupation,
        address1,
        address2,
        dob,
        landmark,
        nomineeFirstName,
        nomineeMiddleName,
        nomineeLastName,
        nomineeDob,
        nomineeAge,
        nomineeRelationship,
      } = action.payload

      if (engineNumber) state.proposalDetails.engineNumber = engineNumber
      if (chassisNumber) state.proposalDetails.chassisNumber = chassisNumber
      if (previousPolicyNumber) state.proposalDetails.previousPolicyNumber = previousPolicyNumber
      // if (isLoan) state.proposalDetails.isLoan = isLoan

      if (isLoan === true || isLoan === false) {
        state.proposalDetails.isLoan = isLoan
      }
      if (bankName) state.proposalDetails.bankName = bankName

      if (usesType) {
        state.proposalDetails.usesType = usesType
      }

      if (salutation) state.proposalDetails.salutation = salutation
      if (firstName) state.proposalDetails.firstName = firstName
      if (middleName) state.proposalDetails.middleName = middleName
      if (lastName) state.proposalDetails.lastName = lastName
      // if (isGenderMale) state.proposalDetails.isGenderMale = isGenderMale
      if (isGenderMale === true || isGenderMale === false) {
        state.proposalDetails.isGenderMale = isGenderMale
      }
      // if (isMarried) state.proposalDetails.isMarried = isMarried
      if (isMarried === true || isMarried === false) {
        state.proposalDetails.isMarried = isMarried
      }
      if (panCard) state.proposalDetails.panCard = panCard
      if (mobileNumber) state.proposalDetails.mobileNumber = mobileNumber
      if (email) state.proposalDetails.email = email
      if (pincodeArea) state.proposalDetails.pincodeArea = pincodeArea
      if (occupation) state.proposalDetails.occupation = occupation
      if (address1) state.proposalDetails.address1 = address1
      if (address2) state.proposalDetails.address2 = address2
      if (dob) state.proposalDetails.dob = dob
      if (landmark) state.proposalDetails.landmark = landmark
      if (nomineeFirstName) state.proposalDetails.nomineeFirstName = nomineeFirstName
      if (nomineeMiddleName) state.proposalDetails.nomineeMiddleName = nomineeMiddleName
      if (nomineeLastName) state.proposalDetails.nomineeLastName = nomineeLastName
      if (nomineeDob) state.proposalDetails.nomineeDob = nomineeDob
      if (nomineeAge) state.proposalDetails.nomineeAge = nomineeAge
      if (nomineeRelationship) state.proposalDetails.nomineeRelationship = nomineeRelationship
    },
    updateProposalSuccessResponse: (state, action: PayloadAction<IProposal>) => {
      state.proposalSuccessResponse = action.payload
    },
    updateProposalErrorResponse: (state, action: PayloadAction<string>) => {
      state.proposalErrorResponse = action.payload
    },
    updateProposalButtonLoadingStatus: (
      state,
      action: PayloadAction<'success' | 'loading' | 'error' | 'not-fetched'>,
    ) => {
      state.proposalStatus = action.payload
    },
    updatePolicyDataFromOCR: (state, action: PayloadAction<IMLPolicyResponse>) => {
      const {
        engine_number,
        chassis_number,
        first_name,
        middle_name,
        last_name,
        address1,
        address2,
      } = action.payload
      state.proposalDetails.engineNumber = engine_number
      state.proposalDetails.chassisNumber = chassis_number
      state.proposalDetails.firstName = first_name
      state.proposalDetails.middleName = middle_name
      state.proposalDetails.lastName = last_name
      state.proposalDetails.address1 = address1
      state.proposalDetails.address2 = address2

      ToastService.showSuccessTaost({
        title: 'Details are fetched from the RC copy uploaded',
        message: 'Please check the details before proceeding further',
      })
    },
    resetProposalStatus: (state) => {
      state.proposalStatus = 'not-fetched'
      state.proposalSuccessResponse = {}
      state.proposalErrorResponse = ''
      state.proposalScreen = 'one'
      state.proposalDetails.pincodeArea = undefined
    },
    resetProposal: () => initialState,
  },
})

const { reducer } = proposalPageSlice

const {
  toggleProposalScreen,
  updateProposalSuccessResponse,
  updateProposalErrorResponse,
  updateProposalDetails,
  updateProposalButtonLoadingStatus,
  updatePolicyDataFromOCR,
  resetProposal,
  resetProposalStatus,
  updateReadOnlyInputs
} = proposalPageSlice.actions

export {
  reducer as proposalPageReducer,
  toggleProposalScreen,
  updateProposalSuccessResponse,
  updateProposalErrorResponse,
  updateProposalDetails,
  updateProposalButtonLoadingStatus,
  updatePolicyDataFromOCR,
  resetProposal,
  resetProposalStatus,
  updateReadOnlyInputs
}
